import { render, staticRenderFns } from "./IncidentQuestionForm.vue?vue&type=template&id=31249c70&scoped=true"
import script from "./IncidentQuestionForm.vue?vue&type=script&lang=js"
export * from "./IncidentQuestionForm.vue?vue&type=script&lang=js"
import style0 from "./IncidentQuestionForm.vue?vue&type=style&index=0&id=31249c70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31249c70",
  null
  
)

export default component.exports